// 特殊处理城市 4个直辖市 czj域名 取市
export const provinceLevelCity = [110000, 120000, 310000, 500000]
// 特殊处理城市 4个直辖市 cekid域名 取省
export const provinceCekidCity = [110100, 120100, 310100, 500100]

// 角色类型
export const ROLETYPE = {
  YUSAO: 99, // 月嫂
  YEGW: 1 // 育儿顾问
}

// 规则类型
export const RULETYPE = {
  NORMAL: 1, // 正价
  ONE: 2, // 一元购下单
  SECKILL: 3, // 秒杀
  GROUP: 4, // 团购
  JIFEN: 5 // 积分
}

// TODO 定制SKU
// 商品打标
export const SKUTAG = {
  SELFSTORE: 1, // 自营到店
  SELFHOME: 2, // 自营到家
  POPYUSAO: 3, // pop-月嫂
  POPTRAIN: 4, // pop-技能培训
  POPENTITY: 5, // pop-实物商品
  POPSTORE: 6, // pop-到店
  POPHOME: 7, // pop-到家
  TICKET: 8, // 景点旅游/门票
  ONLINE: 9, // 在线教育
  UNIONHOME: 10, //联营到家
  APPLIANCE_WASHING: 11, //家电洗护
  STORE_SPECIAL: 12 //到店特殊12（适用门店、带采集信息）
}
// 打标需要收集字段
export const SKUTAGNEED = {
  [SKUTAG.SELFHOME]: {
    worker: true,
    time: true,
    address: true
  },
  [SKUTAG.SELFSTORE]: {
    store: true, // 自营门店
    worker: true,
    time: true
  },
  [SKUTAG.POPYUSAO]: {
    address: true,
    worker: false,
    time: true
  },
  [SKUTAG.POPTRAIN]: {
    // 技能培训去掉收货地址，增加了POP门店信息
    address: true,
    student: true,
    POP_STORE: true,
    time: false
  },
  [SKUTAG.POPENTITY]: {
    address: true,
    time: false,
    worker: false
  },
  [SKUTAG.POPSTORE]: {
    // POP到店不展示服务时间、收货地址，增加了POP门店信息
    time: false,
    address: false,
    worker: false,
    POP_STORE: true
  },
  [SKUTAG.POPHOME]: {
    // POP到家去掉服务时间，不展示门店模块
    address: true,
    time: false,
    worker: false
  },
  [SKUTAG.TICKET]: {
    // 门票
    address: false,
    time: false,
    worker: false,
    collect: true
  },
  [SKUTAG.ONLINE]: {
    // 在线教育
    address: false,
    time: false,
    worker: false,
    collect: true
  },
  [SKUTAG.UNIONHOME]: {
    // 联营到家
    address: true,
    time: false,
    worker: false
  },
  [SKUTAG.APPLIANCE_WASHING]: {
    // 家电洗护
    address: true,
    worker: false,
    time: true
  },
  [SKUTAG.STORE_SPECIAL]: {
    // 到店特殊类型（适用门店、带采集信息）
    address: false,
    time: false,
    worker: false,
    collect: true
  }
}

const identityList = [
  {
    type: 'signed',
    icon: 'signed-two',
    name: '二星月嫂'
  },
  {
    type: 'signed',
    icon: 'signed-three',
    name: '三星月嫂'
  },
  {
    type: 'signed',
    icon: 'signed-four',
    name: '四星月嫂'
  },
  {
    type: 'signed',
    icon: 'signed-five',
    name: '五星月嫂'
  },
  {
    type: 'signed',
    icon: 'signed-gold',
    name: '金牌月嫂'
  },
  {
    type: 'signed',
    icon: 'signed-senior',
    name: '资深月嫂'
  },
  {
    type: 'signed',
    icon: 'signed-diamond',
    name: '钻石月嫂'
  },
  {
    type: 'joint',
    icon: 'joint',
    name: '月嫂'
  },
  {
    type: 'cert',
    icon: 'cert',
    name: '认证育儿师'
  }
]

export const GradeList = [
  {
    id: 6,
    name: '二星月嫂'
  },
  {
    id: 1,
    name: '三星月嫂'
  },
  {
    id: 2,
    name: '四星月嫂'
  },
  {
    id: 3,
    name: '五星月嫂'
  },
  {
    id: 4,
    name: '金牌月嫂'
  },
  {
    id: 5,
    name: '资深月嫂'
  },
  {
    id: 7,
    name: '钻石月嫂'
  }
]

export function identityLabel(labelName) {
  let labelObj = null
  identityList.every(item => {
    const el = item.name === labelName
    labelObj = item
    return !el
  })
  return labelObj
}

export default { identityLabel, provinceLevelCity, provinceCekidCity }
